//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ShareIcon from '@mui/icons-material/Share';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Divider, Button, theme } from 'antd';
import { DashboardOne, SettingTwo, DocumentFolder, AddOne, ViewList, ShareOne, UserBusiness } from '@icon-park/react';
// images
import profileImg from "../../assets/img/profile.png"
import SettingImg from '../../assets/img/setting.png'
import logoutImg from "../../assets/img/logout.png"
import briefcaseImg from "../../assets/img/archive.png";
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'
import { userLogoutAction } from "../../Redux/actions/authAction";
import { useDispatch } from "react-redux";
import ROUTES from "../../docRoutes/docRoutes";
// import { LogoApi } from "Services/bidgrid/master/company Logo/bidLogo";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import DefaultImage from '../../assets/img/profile.jpg';
import { useFetch } from "../../Services/useFetch";
import dayjs from "dayjs";
import { DocImgBaseUrl } from "../../utils/configurable"
const { useToken } = theme;



const UserProfile = () => {

  const location = useLocation();
  const path = location.pathname;
  const { userInfo } = useSelector((state) => state.userDetails)
  // const { companydetails } = useSelector((state) => state?.companyData)
  const [notificationHistory, setNotificationHistory] = useState([])
  const [logo, setLogo] = useState()
  //notification states
  const [notification, setNotification] = useState([])
  const [designation, setDesignation] = useState()
  const { request } = useFetch()

  const dispatch = useDispatch();
  const [menuList, setMenuList] = useState({
    master: false,
    add: false,
    profile: false,
  })
  const [activeMenu, setActiveMenu] = useState(localStorage.getItem('activeItem') || null)

  const [overlayShow, setOverlayShow] = useState(false)

  const CompanyLogo = async () => {
    try {
      // const response = await LogoApi.getLogo()
      const response = await request('/get-company-logo', 'get', null, { 'Content-Type': "application/x-www-form-urlencoded" })

      if (response?.data?.status == 1) {
        // setLogo(response?.data?.data)
        setLogo({ docname: response?.data?.data?.logo_file_name, docpath: response?.data?.data?.logo_file_path, })
      }
      else {
        // notify(response?.response?.data?.message)
      }
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    if (localStorage.getItem('docGridToken')) {
      CompanyLogo()
    }
  }, [localStorage.getItem('docGridToken')])


  const handleMenu = (e, name) => {
    setMenuList({
      master: name === "master" ? !menuList.master : false,
      add: name === "add" ? !menuList.add : false,
      profile: name === "profile" ? !menuList.profile : false,
    });
    setActiveMenu(name)
    localStorage.setItem('activeItem', name);

  };

  useEffect(() => {
    if (menuList.master === true || menuList.add === true || menuList.profile === true) {
      setOverlayShow(true)
    } else {
      setOverlayShow(false)
    }
  }, [menuList])


  const handleClickOutside = (e) => {
    const headerLastElement = document.getElementsByClassName("bd_profileMenu")[0];
    const headerMasterElement = document.getElementsByClassName("Master_menu")[0];
    const headerAddElement = document.getElementsByClassName("Add_menu")[0];

    if (
      (!headerLastElement || !headerLastElement.contains(e.target)) &&
      (!headerMasterElement || !headerMasterElement.contains(e.target)) &&
      (!headerAddElement || !headerAddElement.contains(e.target))
    ) {
      setMenuList({
        master: false,
        add: false,
        profile: false,
      });
      setOverlayShow(false)
    }
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedActiveItem = localStorage.getItem('activeItem');
    if (storedActiveItem) {
      setActiveMenu(storedActiveItem);
    }
  }, []);

  useEffect(() => {
    let pathname = window.location.pathname.split('/')[2];
    setActiveMenu(pathname)
  }, [window.location.pathname])

  const handleLogout = () => {
    dispatch(userLogoutAction({ global: true }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  const scrollToBottom = () => {
    const targetPosition = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight - 0
    );

    window.scroll({
      top: targetPosition,
      behavior: "smooth",
    });
  };


  function convertHtmlToText(item) {
    return item?.replace(/<[^>]*>/g, '')
  }


  const { token } = useToken();
  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  };
  const menuStyle = {
    boxShadow: 'none',
  };
  return (
    <div className="bg_header not-fixed" >
      <div className="bd_profileMenu" onClick={(e) => handleMenu(e, "profile")}>
        <div className="bd_userProfile">
          {userInfo?.profileimg ?
            <img alt='' className="img-thumbnail rounded-circle"
              src={userInfo?.profileimg !== null ? `${DocImgBaseUrl}${userInfo.profileimg_path}/${userInfo.profileimg}` : DefaultImage}
              width={50}
            /> :
            <Avatar style={{ width: '40px', height: '40px' }}>
              {userInfo?.firstname !== null ?
                userInfo?.firstname?.charAt(0) : userInfo?.userfullname?.charAt(0)}
            </Avatar>
          }
        </div>
        {/* <div className="bd_para">
          <h4>{userInfo?.userfullname} </h4>
          <p>{designation}</p>
        </div> */}

        {/* <div style={{}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" >
            <path d="M5 7.5L10 12.5L15 7.5" stroke="#636363" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div> */}
        <div className={
          menuList.profile ? "bg_megamenu Bd_menu_visible" : "bg_megamenu"
        }>
          <div className="rowGridFlex">
            <div className="megaLink">
              <span style={{ textTransform: 'capitalize', paddingBottom: '8px', fontFamily: 'serif' }}>
                Hi, {userInfo?.userfullname}
                <p>{designation}</p>
              </span>
            </div>


            <div className="megaLink">
              <Link to={ROUTES?.PROFILE} >
                <span>
                  <img src={profileImg} alt="" />
                  Profile
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" >
                  <path d="M7 13.5L11.5 9L7 4.5" stroke="#DADADA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            </div>
            {/* <div className="megaLink" >
                  <Link to={ROUTES?.briefcase}>
                    <span>
                      <img src={briefcaseImg} style={{ width: 22, opacity: ".6" }} />
                      Briefcase
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" >
                      <path d="M7 13.5L11.5 9L7 4.5" stroke="#DADADA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Link>
                </div> */}
            {
              userInfo?.permanent_sys_adm == "2" ? (
                <>
                </>
              ) : <>
                <div className="megaLink" >
                  <Link to={ROUTES?.EMPLOYEE}>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                        <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                      </svg>                        Users
                    </span>
                  </Link>
                </div>
                <div className="megaLink" >
                  <Link to={ROUTES?.SETTING}>
                    <span>
                      <img src={SettingImg} alt="profileImg" style={{ width: 22, opacity: ".6" }} />
                      Setting
                    </span>
                  </Link>
                </div>
              </>
            }
            <div className="megaLink" onClick={(e) => handleMenu(e, "profile")}>
              <a >
                <span onClick={handleLogout}>
                  <img src={logoutImg} alt="" />
                  Logout
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18">
                  <path d="M7 13.5L11.5 9L7 4.5" stroke="#DADADA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserProfile